module.exports = __webpack_public_path__ + "img/Wiper.6321b135.jpg";